import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const TOKEN_KEY = "mg_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // If no admin token but we have a public user token, use it (unless caller set one explicitly)
  else {
    const pub = localStorage.getItem("mg_public_token");
    if (pub && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${pub}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Auto-broadcast a "settings-updated" event whenever the admin performs a mutation
    // so the public site (SiteConfig + useLiveResource hooks) refetches immediately.
    try {
      const cfg = r.config || {};
      const method = (cfg.method || "get").toLowerCase();
      const url = cfg.url || "";
      const isMutation = ["post", "put", "patch", "delete"].includes(method);
      const isAdminUrl = url.includes("/admin/");
      if (isMutation && isAdminUrl) {
        window.dispatchEvent(new Event("grupomanga:settings-updated"));
        try { localStorage.setItem("grupomanga:settings-updated", String(Date.now())); } catch {}
      }
    } catch {
      /* noop */
    }
    return r;
  },
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.endsWith("/admin")) {
      // token invalid on a protected admin call
    }
    return Promise.reject(err);
  },
);

export function apiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Resolve image paths: relative paths (/games/x.jpg, /api/images/x) work same-origin.
export const imgUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BASE}${path}`;
  return path;
};
